module.exports = __webpack_public_path__ + "img/电子证书图.a4a39e2e.png";